<!-- Prestando el flujo de responder a «Mi equipo» (vista «resolver», desde
     el 29/10/2026) no se dibuja nada: sólo la firma, al pie. -->
<div class="per table-page table-page--compact table-page--dense" *ngIf="vista !== 'resolver'">

  <!-- ==================== Encabezado ====================
       El mismo de «Mis vacaciones» (25/09/2026, «que se vea elegante»):
       el icono de la pestaña en su insignia, el título y la frase debajo.
       Es el único encabezado de la pantalla. Desde el 30/09/2026 sin el
       botón «Pedir permiso»: el asistente ya está a la vista. -->
  <section class="table-page__hero per-hero" *ngIf="vista !== 'resolver'">
    <div class="table-page__copy per-hero__copy">
      <span class="material-icons per-hero__icono" aria-hidden="true">assignment_turned_in</span>
      <div class="per-hero__textos">
        <h1>Mis permisos</h1>
        <p>Para faltar un día, salir antes o llegar más tarde. Se firma el <span class="per-nobr">FRC-017</span>.</p>
      </div>
    </div>
  </section>

  <!-- ==================== ESPERAN TU RESPUESTA ====================
       Va antes que todo: si alguien espera, es lo primero que hay que ver
       al entrar (como «Por resolver» en Vacaciones). Sólo se dibuja para
       quien tiene algo que resolver. Estuvo únicamente en el calendario
       de permisos, pero ese menú lo tienen dos personas y los demás
       líderes se quedaban sin forma de contestar a su gente. -->
  <!-- El borde ámbar (y en los temas el fondo) es el de la bandeja de
       Vacaciones: «pide atención» sin gritar. Desde el 29/10/2026 sólo en
       la vista que junta las dos partes: «Mi equipo» dibuja la suya con el
       renglón de las vacaciones. -->
  <section class="table-page__card per-resolver" *ngIf="vista !== 'pedir' && porResolver.length">
    <div class="per-resolver__cab">
      <span class="material-icons" aria-hidden="true">notifications_active</span>
      <h2 class="per-seccion">
        <b>{{ porResolver.length }}</b>
        {{ porResolver.length === 1 ? 'permiso espera' : 'permisos esperan' }}
        tu respuesta
      </h2>
    </div>

    <div class="table-page__table-wrap">
      <table class="table-page__table per-tabla per-tabla--resolver">
        <thead>
          <tr>
            <th class="per-col--quien">Colaborador</th>
            <th class="per-col--permiso">Permiso</th>
            <th>Observaciones</th>
            <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of porResolver; trackBy: trackPermiso">
            <td class="per-rtd--quien">
              <div class="table-page__cell-stack">
                <strong class="table-page__name">{{ p.colaborador }}</strong>
                <!-- Le llega por suplencia: se dice de quién es y por qué,
                     para que no lo resuelva creyendo que es de su gente. -->
                <span class="table-page__subtext per-suplencia" *ngIf="p.suplenteDe">
                  <span class="material-icons" aria-hidden="true">swap_vert</span>
                  Te llega a ti: {{ p.suplenteDe }} está {{ p.ausencia }}
                </span>
                <!-- Le llega porque nadie más puede: sin autorizador en el saldo. -->
                <span class="table-page__subtext per-suplencia" *ngIf="p.sinAutorizador">
                  <span class="material-icons" aria-hidden="true">person_off</span>
                  Te llega a ti: no tiene autorizador asignado
                </span>
              </div>
            </td>
            <td class="per-rtd--permiso">
              <ng-container *ngTemplateOutlet="celdaPermiso; context: { $implicit: p }"></ng-container>
            </td>
            <td class="per-rtd--obs">
              <span class="table-page__text per-nota" *ngIf="p.observaciones; else sinObs"
                    [attr.title]="p.observaciones">{{ p.observaciones }}</span>
            </td>
            <td class="table-page__actions table-page__actions--multi">
              <div class="table-page__action-group">
                <button type="button" class="table-page__action-btn"
                        *ngIf="p.tieneFirma"
                        matTooltip="El FRC-017 firmado por quien pide" aria-label="FRC-017"
                        [disabled]="generandoFrc === p.idPermiso"
                        (click)="frcDe(p)">
                  <span class="material-icons">description</span>
                </button>
                <!-- Si quien pide lo firmó en papel y ya lo subió, se ve
                     aquí. Subirlo es de su lista, no de la bandeja. -->
                <app-frc-firmado *ngIf="p.tieneFirma"
                                 variante="icono"
                                 tipo="PERMISO"
                                 [id]="p.idPermiso"
                                 [enPapel]="!!p.enPapel"
                                 [firmado]="p.firmado"
                                 [puedeSubir]="false"></app-frc-firmado>
                <!-- Solo icono, como toda tabla del estandar. El check va en
                     verde y la cruz en rojo: los dos del mismo color no se
                     distinguen. -->
                <button type="button" class="table-page__action-btn per-accion--si"
                        title="Autorizar" aria-label="Autorizar"
                        [disabled]="resolviendo === p.idPermiso"
                        (click)="autorizar(p)">
                  <span class="material-icons">check</span>
                </button>
                <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                        title="No autorizar" aria-label="No autorizar"
                        [disabled]="resolviendo === p.idPermiso"
                        (click)="rechazar(p)">
                  <span class="material-icons">close</span>
                </button>
              </div>
              <!-- En tarjeta (caja angosta, como el teléfono), con
                   texto y al pie, como las vacaciones: el FRC a
                   la izquierda, «No» y «Autorizar» a la derecha. En la tabla
                   ancha sólo se ven los íconos de arriba. -->
              <div class="per-acciones-texto">
                <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                        *ngIf="p.tieneFirma"
                        matTooltip="El FRC-017 firmado por quien pide"
                        [disabled]="generandoFrc === p.idPermiso"
                        (click)="frcDe(p)">
                  <span class="material-icons">description</span>
                  FRC-017
                </button>
                <app-frc-firmado *ngIf="p.tieneFirma"
                                 tipo="PERMISO"
                                 [id]="p.idPermiso"
                                 [enPapel]="!!p.enPapel"
                                 [firmado]="p.firmado"
                                 [puedeSubir]="false"></app-frc-firmado>
                <!-- Juntos y a la derecha: si con el FRC firmado a mano ya
                     no caben en el renglón, bajan los dos y siguen ahí. -->
                <span class="per-acciones-texto__decide">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                          [disabled]="resolviendo === p.idPermiso"
                          (click)="rechazar(p)">
                    <span class="material-icons">close</span>
                    No
                  </button>
                  <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                          [disabled]="resolviendo === p.idPermiso"
                          (click)="autorizar(p)">
                    <span class="material-icons">check</span>
                    Autorizar
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- ==================== Lo de arriba ====================
       30/09/2026 (Norman, tras el asistente de Vacaciones: «y permisos
       sigue igual»): el mismo acomodo y las mismas piezas que la pestaña
       Vacaciones (../vacaciones/asistente-comun.css). A la izquierda el
       asistente para pedir; a la derecha lo que lleva en el año y «Tus
       permisos». En angosto, una columna. -->
  <div class="asi-inicio" *ngIf="vista !== 'resolver'">
  <div class="asi-inicio__rejilla">

    <!-- ==================== Pedir: el asistente ==================== -->
    <section class="table-page__card asi-wiz" aria-labelledby="perWizTit">
      <header class="asi-wiz__cab">
        <h2 id="perWizTit" class="asi-wiz__tit">Pedir permiso</h2>

        <ol class="asi-pasos" aria-label="Pasos para pedir un permiso">
          <li *ngFor="let p of PASOS; let i = index"
              class="asi-pasos__paso"
              [class.es-actual]="i === indicePaso"
              [class.es-hecho]="i < indicePaso">
            <button type="button" class="asi-pasos__btn"
                    [disabled]="!puedeIrA(i)" (click)="irAPaso(i)"
                    [attr.aria-current]="i === indicePaso ? 'step' : null">
              <span class="asi-pasos__num" aria-hidden="true">
                <span class="material-icons" *ngIf="i < indicePaso; else numero">check</span>
                <ng-template #numero>{{ i + 1 }}</ng-template>
              </span>
              <span class="asi-pasos__txt">{{ p.texto }}</span>
            </button>
          </li>
        </ol>
      </header>

      <!-- ========== 1. Qué y cuándo ==========
           Arriba las tres opciones del formato; abajo el calendario a la
           vista (de lunes a viernes y de hoy en adelante) y, a su lado, el
           día, la hora cuando la pide y las observaciones. -->
      <div class="asi-wiz__cuerpo per-que" *ngIf="paso === 'que'">
        <!-- Las tres opciones del formato. Sólo se marca una. Cada una con
             su icono en el color de su tipo, el mismo de la lista y del
             calendario de permisos. -->
        <div class="per-campo--ops">
          <!-- Sin la etiqueta «¿Qué necesitas?» a la vista (30/09/2026, «no
               quiero scroll»): el paso ya se llama «Qué y cuándo» y las tres
               fichas se explican solas. El lector de pantalla sí la oye. -->
          <div class="per-ops" role="radiogroup" aria-label="¿Qué necesitas?">
            <button type="button" class="per-op"
                    *ngFor="let o of OPCIONES"
                    role="radio"
                    [class.es-activa]="tipo === o.valor"
                    [attr.aria-checked]="tipo === o.valor"
                    (click)="cambiaTipo(o.valor)">
              <span class="per-tipo per-tipo--chico" [ngClass]="tonoDe(o.valor)" aria-hidden="true">
                <span class="material-icons">{{ iconoDe(o.valor) }}</span>
              </span>
              <span class="per-op__txt">{{ o.texto }}</span>
            </button>
          </div>
        </div>

        <div class="asi-eleccion">
          <!-- El calendario de Material y no <input type="date">: el del
               navegador no puede bloquear el fin de semana. Entre semana y
               de hoy en adelante (14/09/2026); el servidor aplica la misma
               regla. En línea desde el 30/09/2026, como el de Vacaciones. -->
          <div class="asi-eleccion__cal">
            <mat-calendar class="asi-cal"
                          [selected]="fechaDia"
                          (selectedChange)="alElegirDia($event)"
                          [startAt]="fechaDia || hoy"
                          [minDate]="hoy"
                          [dateFilter]="soloDiasValidos"
                          [dateClass]="claseDia"></mat-calendar>
          </div>

          <div class="asi-eleccion__lado">
            <!-- El día y, en las dos opciones que la piden, la hora: lado a
                 lado, como «Primer día / Último día» en Vacaciones (30/09/2026:
                 la hora en su propio renglón hacía rodar la pantalla). La que
                 toca llenar lleva el anillo del acento. Qué sigue, en
                 palabras, va al pie junto a «Siguiente» (asi-wiz__guia). -->
            <div class="per-puntas" [class.con-hora]="opcion.pideHora">
              <div class="asi-punta" [class.es-espera]="!fechaDia">
                <span class="asi-punta__et">Día del permiso</span>
                <span class="asi-punta__val" *ngIf="fechaDia; else sinDia">{{ diaCorto(fechaDia) }}</span>
                <ng-template #sinDia>
                  <span class="asi-punta__val asi-punta__val--falta">Por elegir</span>
                </ng-template>
              </div>
              <label class="asi-punta per-hora" *ngIf="opcion.pideHora"
                     [class.es-espera]="!!fechaDia && !hora">
                <span class="asi-punta__et">{{ opcion.etiquetaHora }}<span class="per-req" aria-hidden="true"> *</span></span>
                <input id="perHora" type="time" class="per-hora__input" required
                       [(ngModel)]="hora" name="hora" />
              </label>
            </div>

            <!-- Lo que se va a pedir, en una línea, en cuanto está completo. -->
            <div class="per-sintesis" *ngIf="fechaDia && !faltaPermiso" aria-live="polite">
              <span class="material-icons" aria-hidden="true">check_circle</span>
              <span><b>{{ sintesisTitulo }}</b>, {{ sintesisDetalle.toLowerCase() }}.</span>
            </div>

            <!-- El goce NO va aquí: lo decide quien autoriza, al resolver.
                 Es una concesión de la empresa, no algo que uno se conceda a
                 sí mismo. -->
            <div class="per-obs">
              <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                <mat-label>Observaciones</mat-label>
                <textarea id="perObs" matInput aria-label="Observaciones" rows="2"
                          maxlength="500" [(ngModel)]="observaciones" name="observaciones"
                          placeholder="Lo que deba constar en el formato (opcional)."></textarea>
              </mat-form-field>
            </div>

            <!-- La leyenda al pie, como en Vacaciones: «Hoy» regresa el
                 calendario al mes de hoy (30/09/2026, Norman: «si le doy
                 click que me regrese a hoy») y al lado, la regla. -->
            <ul class="asi-leyenda">
              <li>
                <button type="button" class="asi-hoy" (click)="verMes(hoy)"
                        matTooltip="Volver al mes de hoy">
                  <span class="asi-leyenda__m asi-leyenda__m--hoy" aria-hidden="true"></span>Hoy
                </button>
              </li>
              <li class="asi-leyenda__nota">De lunes a viernes, de hoy en adelante.</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- ========== 2. Revisa (y 3. mientras firma) ==========
           Lo que va a decir el FRC-017, a la vista, con el encabezado del
           formato para corregirlo si hace falta. La firma se abre en su
           ventana de siempre; mientras, esto se queda debajo. -->
      <div class="asi-wiz__cuerpo asi-rev"
           *ngIf="(paso === 'revisa' || paso === 'firma') && fechaDia">
        <div class="asi-rev__viaje es-un-dia" role="group" [attr.aria-label]="enUnaFrase">
          <div class="asi-hoja" aria-hidden="true">
            <span class="asi-hoja__mes">
              {{ mesDe(fechaDia) }}<small *ngIf="anioSiOtro(fechaDia)"> {{ anioSiOtro(fechaDia) }}</small>
            </span>
            <span class="asi-hoja__dia">{{ fechaDia.getDate() }}</span>
            <span class="asi-hoja__sem">{{ semanaDe(fechaDia) }}</span>
          </div>

          <div class="per-rev__que">
            <span class="per-tipo" [ngClass]="tonoDe(tipo)" aria-hidden="true">
              <span class="material-icons">{{ iconoDe(tipo) }}</span>
            </span>
            <div class="per-rev__txt">
              <b>{{ queTexto }}</b>
              <span>{{ diaLargo(fecha) }}</span>
              <q class="per-rev__obs" *ngIf="observaciones.trim()">{{ observaciones.trim() }}</q>
            </div>
          </div>
        </div>

        <!-- El encabezado del FRC-017. Viene del organigrama y se corrige:
             no toda rama tiene los tres niveles, y el papel se firma con lo
             que diga aquí. Se abre solo si falta algo. -->
        <section class="per-formato" aria-labelledby="perFormatoTit">
          <div class="per-formato__cab">
            <h3 id="perFormatoTit" class="per-formato__tit">Datos del formato</h3>
            <span class="per-formato__pista">salen del organigrama</span>
            <span class="asi-wiz__hueco"></span>
            <button type="button" class="per-formato__editar"
                    *ngIf="!editandoFormato && paso === 'revisa'"
                    (click)="editandoFormato = true">
              <span class="material-icons" aria-hidden="true">edit</span>
              Corregir
            </button>
          </div>

          <!-- Sus datos en dos columnas, sin fichas: con fichas el paso
               medía más que la ventana y la pantalla rodaba. -->
          <dl class="per-formato__datos" *ngIf="!editandoFormato">
            <div>
              <dt>Área</dt>
              <dd>{{ area.trim() || '—' }}</dd>
            </div>
            <div>
              <dt>Líder / jefe directo</dt>
              <dd>{{ jefeDirecto.trim() || '—' }}</dd>
            </div>
            <div>
              <dt>Director de área</dt>
              <dd>{{ directorArea.trim() || '—' }}</dd>
            </div>
            <div>
              <dt>Gerente operativo</dt>
              <dd>{{ gerenteOperativo.trim() || '—' }}</dd>
            </div>
          </dl>

          <div class="per-formato__campos" *ngIf="editandoFormato">
            <div class="per-campo">
              <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                <mat-label class="per-lbl--req">Área</mat-label>
                <input id="perArea" matInput aria-label="Área" type="text" maxlength="80"
                       [(ngModel)]="area" name="area" />
              </mat-form-field>
            </div>
            <!-- Select y no texto: en un área puede haber varios líderes y
                 quien pide sabe cuál es el suyo mejor que el organigrama,
                 sobre todo si se movió de proyecto. Se ofrecen los de su
                 área que tienen gente a cargo, más su cadena de mando. -->
            <div class="per-campo">
              <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic"
                              *ngIf="!jefeLibre">
                <mat-label class="per-lbl--req">Líder de Proyecto / Jefe directo</mat-label>
                <select id="perJefe" matNativeControl aria-label="Líder de Proyecto / Jefe directo"
                        [(ngModel)]="jefeDirecto" name="jefeDirecto"
                        (ngModelChange)="cambiaJefe($event)">
                  <option value="">— Escoge a tu líder —</option>
                  <option *ngFor="let j of jefes" [value]="j">{{ j }}</option>
                  <option [value]="OTRO">Otro… (escribirlo)</option>
                </select>
              </mat-form-field>

              <!-- El organigrama no siempre tiene la caja de todos; sin esta
                   salida, quien no aparezca en la lista no podría pedir. -->
              <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic"
                              *ngIf="jefeLibre">
                <mat-label class="per-lbl--req">Líder de Proyecto / Jefe directo</mat-label>
                <input matInput aria-label="Líder de Proyecto / Jefe directo" type="text" maxlength="120"
                       placeholder="Nombre de tu líder o jefe directo"
                       [(ngModel)]="jefeDirecto" name="jefeDirectoLibre" />
                <button type="button" matIconSuffix class="per-sufijo" (click)="volverALista()"
                        matTooltip="Volver a la lista" aria-label="Volver a la lista">
                  <span class="material-icons">list</span>
                </button>
              </mat-form-field>
            </div>
            <div class="per-campo">
              <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                <mat-label>Director de Área</mat-label>
                <input id="perDir" matInput aria-label="Director de Área" type="text" maxlength="120"
                       [(ngModel)]="directorArea" name="directorArea" />
              </mat-form-field>
            </div>
            <div class="per-campo">
              <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                <mat-label>Gerente Operativo</mat-label>
                <input id="perGer" matInput aria-label="Gerente Operativo" type="text" maxlength="120"
                       [(ngModel)]="gerenteOperativo" name="gerenteOperativo" />
              </mat-form-field>
            </div>
          </div>
        </section>

        <p class="asi-rev__firma">
          <span class="material-icons" aria-hidden="true">draw</span>
          <span>
            Al continuar firmas tu <b>FRC-017</b>: digital aquí mismo, o lo
            descargas para firmarlo a mano. Después se envía a autorización.
          </span>
        </p>
      </div>

      <!-- ========== Listo ==========
           En vez del «Permiso solicitado» en una ventana: el asistente lo
           dice en su lugar y el permiso aparece resaltado en «Tus
           permisos». -->
      <div class="asi-wiz__cuerpo asi-listo" *ngIf="paso === 'listo' && enviada" role="status">
        <span class="asi-listo__ok" aria-hidden="true">
          <span class="material-icons">check</span>
        </span>
        <h3 class="asi-listo__tit">¡Listo! Tu permiso va en camino</h3>
        <p class="asi-listo__que">Pediste <b>{{ enviada.que }}</b>.</p>
        <!-- A quién le llegó lo dice la lista recién cargada. -->
        <p class="asi-listo__quien" *ngIf="!cargando">
          <ng-container *ngIf="quienResponde; else sinQuien">
            Le llegó a <b>{{ quienResponde }}</b> para autorizarlo.
          </ng-container>
          <ng-template #sinQuien>Le llegó a quien autoriza tus permisos.</ng-template>
          Te avisamos aquí cuando lo resuelva.
        </p>
        <!-- «Descargar para firmar»: el FRC-017 ya se descargó, y el papel
             firmado se sube desde el permiso (ver app-frc-firmado). -->
        <p class="asi-listo__papel" *ngIf="enviada.papel">
          <span class="material-icons" aria-hidden="true">description</span>
          <span>
            Se descargó tu FRC-017. Fírmalo a mano y súbelo desde «Tus permisos»
            con el botón de subir el firmado.
          </span>
        </p>
      </div>

      <footer class="asi-wiz__pie">
        <ng-container *ngIf="paso === 'que'">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  *ngIf="fechaDia || hora || observaciones" (click)="limpiaPermiso()">
            <span class="material-icons" aria-hidden="true">restart_alt</span>
            Limpiar
          </button>
          <!-- Qué sigue, en palabras, mientras falta el día o la hora. -->
          <span class="asi-wiz__guia" *ngIf="!fechaDia" aria-live="polite">
            <span class="material-icons" aria-hidden="true">touch_app</span>
            <b>Toca en el calendario el día del permiso.</b>
          </span>
          <span class="asi-wiz__guia" *ngIf="fechaDia && opcion.pideHora && !hora" aria-live="polite">
            <span class="material-icons" aria-hidden="true">schedule</span>
            <b>Ahora escribe la {{ opcion.etiquetaHora.toLowerCase() }}.</b>
          </span>
          <span class="asi-wiz__hueco"></span>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                  [disabled]="!!faltaPermiso" (click)="aRevisar()">
            Siguiente
            <span class="material-icons" aria-hidden="true">arrow_forward</span>
          </button>
        </ng-container>

        <ng-container *ngIf="paso === 'revisa' || paso === 'firma'">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  [disabled]="paso !== 'revisa'" (click)="aQue()">
            <span class="material-icons" aria-hidden="true">arrow_back</span>
            Cambiar
          </button>
          <span class="asi-wiz__hueco"></span>
          <span class="asi-wiz__falta" *ngIf="faltaFormato && paso === 'revisa'" role="alert">
            <span class="material-icons" aria-hidden="true">info_outline</span>
            {{ faltaFormato }}
          </span>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                  [disabled]="paso !== 'revisa' || !!falta" (click)="firmarYEnviar()">
            <span class="material-icons" aria-hidden="true">{{ enviando ? 'hourglass_top' : 'draw' }}</span>
            {{ enviando ? 'Enviando…' : 'Firmar y enviar' }}
          </button>
        </ng-container>

        <ng-container *ngIf="paso === 'listo'">
          <span class="asi-wiz__hueco"></span>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  (click)="otroPermiso()">
            <span class="material-icons" aria-hidden="true">add</span>
            Pedir otro permiso
          </button>
        </ng-container>
      </footer>
    </section>

    <!-- ==================== Al lado: el año y tus permisos ==================== -->
    <div class="asi-lado">

      <!-- Lo que lleva en el año, por tipo y con su color: el lugar que en
           Vacaciones tiene el saldo. Cuentan los autorizados y los que
           esperan respuesta; los retirados y los no autorizados, no. -->
      <div class="per-cifras">
        <div class="per-cifras__cab">
          <span class="material-icons" aria-hidden="true">insights</span>
          <span>Tus permisos de <b>{{ anio }}</b></span>
          <span class="per-cifras__nota">· autorizados y en espera</span>
        </div>
        <!-- Cada ficha en horizontal (insignia, número y tipo): la tarjeta
             mide la mitad y deja lugar a la lista sin que la pantalla ruede. -->
        <div class="per-cifras__fichas">
          <div class="per-cifra" *ngFor="let o of OPCIONES">
            <span class="per-tipo per-tipo--chico" [ngClass]="tonoDe(o.valor)" aria-hidden="true">
              <span class="material-icons">{{ iconoDe(o.valor) }}</span>
            </span>
            <span class="per-cifra__num">{{ cifras[o.valor] }}</span>
            <span class="per-cifra__et">{{ etiquetaCifra(o.valor) }}</span>
          </div>
        </div>
      </div>

      <!-- ==================== Los míos ====================
           Con título corto, como «Tus vacaciones» en la otra pestaña, y el
           filtro por estado con cuántos hay de cada uno. En la columna
           derecha cada renglón se acomoda como tarjeta (ver «Tus permisos»
           en el CSS). -->
      <section class="table-page__card per-lista">
        <!-- Por páginas de los que caben, con el paginado aquí arriba y no
             en el pie (30/09/2026, Norman: «no quiero scroll ... paginado»). -->
        <div class="per-lista__cab">
          <h2 class="per-seccion">Tus permisos</h2>
          <nav class="asi-pagina" *ngIf="!cargando && totalPaginas() > 1" aria-label="Páginas de tus permisos">
            <button type="button" class="table-page__pager-link" (click)="paginaAnterior()"
                    [disabled]="paginaNorm() <= 1" title="Página anterior" aria-label="Página anterior">
              <span class="material-icons">chevron_left</span>
            </button>
            <span class="asi-pagina__txt">{{ paginaNorm() }} de {{ totalPaginas() }}</span>
            <button type="button" class="table-page__pager-link" (click)="paginaSiguiente()"
                    [disabled]="paginaNorm() >= totalPaginas()" title="Página siguiente" aria-label="Página siguiente">
              <span class="material-icons">chevron_right</span>
            </button>
          </nav>

          <!-- El filtro, del color de cada estado (el de la franja del
               renglón) y con cuántos hay. Se prende y se apaga; puesto, su
               cuenta se vuelve una × al pasar encima. Uno sin ninguno no se
               puede escoger; los retirados sólo salen sin filtro. -->
          <div class="asi-filtros" role="group" aria-label="Filtrar tus permisos por estado"
               *ngIf="mios.length">
            <button type="button" class="asi-filtro" *ngFor="let f of FILTROS"
                    [ngClass]="f.clase"
                    [class.es-activo]="filtro === f.id"
                    [attr.aria-pressed]="filtro === f.id"
                    [disabled]="!cuentas[f.id] && filtro !== f.id"
                    [matTooltip]="filtro === f.id ? 'Quitar el filtro' : ''"
                    (click)="filtra(f.id)">
              {{ f.texto }}
              <span class="asi-filtro__n">
                <span class="asi-filtro__num">{{ cuentas[f.id] }}</span>
                <span class="material-icons asi-filtro__x" aria-hidden="true">close</span>
              </span>
            </button>
            <!-- Los retirados que archivó (14/10/2026): sólo salen aquí, y el
                 filtro sólo aparece si hay alguno. -->
            <button type="button" class="asi-filtro asi-filtro--archivo" *ngIf="cuentas.ARCHIVADOS"
                    [class.es-activo]="filtro === 'ARCHIVADOS'"
                    [attr.aria-pressed]="filtro === 'ARCHIVADOS'"
                    [matTooltip]="filtro === 'ARCHIVADOS' ? 'Quitar el filtro' : 'Los retirados que archivaste'"
                    (click)="filtra('ARCHIVADOS')">
              Archivados
              <span class="asi-filtro__n">
                <span class="asi-filtro__num">{{ cuentas.ARCHIVADOS }}</span>
                <span class="material-icons asi-filtro__x" aria-hidden="true">close</span>
              </span>
            </button>
          </div>
        </div>

        <!-- Cada renglón lleva a la izquierda la franja de su estado (ámbar
             espera, verde autorizado, rojo no autorizado), la misma de las
             tarjetas de Vacaciones. El día manda en la primera columna; quién
             responde y su motivo, juntos en la suya; el estatus, corto. -->
        <div class="table-page__table-wrap" *ngIf="filtrados.length; else perVacio">
          <table class="table-page__table per-tabla">
            <thead>
              <tr>
                <th class="per-col--permiso">Permiso</th>
                <th class="per-col--obs">Observaciones</th>
                <th class="per-col--quien">Quién responde</th>
                <th class="per-col--estatus">Estatus</th>
                <th class="table-page__actions-head">Acciones</th>
              </tr>
            </thead>
            <tbody #filasPer>
              <tr *ngFor="let p of miosPagina(); trackBy: trackPermiso" [ngClass]="fila(p)"
                  [class.es-nueva]="p.idPermiso === recienPedido">
                <td class="per-td--permiso">
                  <ng-container *ngTemplateOutlet="celdaPermiso; context: { $implicit: p, quien: quienCorto(p) }"></ng-container>
                </td>
                <td class="per-td--obs">
                  <span class="table-page__text per-nota" *ngIf="p.observaciones; else sinObs"
                        [attr.title]="p.observaciones">{{ p.observaciones }}</span>
                </td>
                <td class="per-td--quien">
                  <!-- En espera: a quién, y si el de siempre está fuera, por qué
                       lo ve otro. Resuelto: quién y su puesto, y si dijo que no,
                       su motivo, que es lo primero que se viene a buscar. -->
                  <ng-container [ngSwitch]="p.estatus">
                    <div class="table-page__cell-stack" *ngSwitchCase="'PENDIENTE'">
                      <span class="table-page__text per-quien">{{ p.esperaA || 'Sin autorizador asignado' }}</span>
                      <span class="table-page__subtext per-suplencia" *ngIf="p.suplenteDe && p.ausencia; else aunNo">
                        <span class="material-icons" aria-hidden="true">swap_vert</span>
                        {{ p.suplenteDe }} está {{ p.ausencia }}
                      </span>
                      <ng-template #aunNo>
                        <span class="table-page__subtext">Aún no responde</span>
                      </ng-template>
                    </div>
                    <span class="table-page__subtext" *ngSwitchCase="'CANCELADO'">Lo retiraste</span>
                    <div class="table-page__cell-stack" *ngSwitchDefault>
                      <span class="table-page__text per-quien" *ngIf="p.autorizaNombre">{{ p.autorizaNombre }}</span>
                      <span class="table-page__subtext" *ngIf="p.autorizaNombre && p.autorizaPuesto">{{ p.autorizaPuesto }}</span>
                      <span class="per-motivo" *ngIf="p.estatus === 'RECHAZADO' && p.motivo"
                            [attr.title]="p.motivo">
                        <span class="material-icons" aria-hidden="true">chat_bubble_outline</span>
                        {{ p.motivo }}
                      </span>
                    </div>
                  </ng-container>
                </td>
                <td class="per-td--estatus">
                  <span class="table-page__status-badge per-estatus" [ngClass]="clase(p)">
                    <span class="material-icons" aria-hidden="true">{{ iconoEstatus(p) }}</span>
                    {{ etiqueta(p) }}
                  </span>
                </td>
                <!-- Retirar primero y el FRC-017 al final: con los dos lugares
                     fijos del CSS, el PDF queda en la misma columna en todos
                     los renglones, tenga o no el de retirar al lado. -->
                <td class="table-page__actions">
                  <div class="table-page__action-group per-acciones-fila">
                    <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                            (click)="retirar(p)"
                            *ngIf="p.estatus === 'PENDIENTE'"
                            matTooltip="Retirar el permiso" aria-label="Retirar el permiso">
                      <span class="material-icons">undo</span>
                    </button>
                    <!-- Retirado: archivarlo para que deje de salir; archivado, sacarlo. -->
                    <button type="button" class="table-page__action-btn" (click)="archivar(p, true)"
                            *ngIf="p.estatus === 'CANCELADO' && !p.archivado" [disabled]="archivando === p.idPermiso"
                            matTooltip="Archivar: deja de salir en tu lista" aria-label="Archivar el permiso">
                      <span class="material-icons">archive</span>
                    </button>
                    <button type="button" class="table-page__action-btn" (click)="archivar(p, false)"
                            *ngIf="p.archivado" [disabled]="archivando === p.idPermiso"
                            matTooltip="Sacar del archivo" aria-label="Sacar el permiso del archivo">
                      <span class="material-icons">unarchive</span>
                    </button>
                    <!-- Firmado en papel («Descargar para firmar»): subir el
                         FRC-017 ya firmado y verlo. Antes del PDF, que se queda
                         siempre a la derecha. -->
                    <app-frc-firmado *ngIf="tieneFrc(p)"
                                     variante="icono"
                                     tipo="PERMISO"
                                     [id]="p.idPermiso"
                                     [enPapel]="!!p.enPapel"
                                     [firmado]="p.firmado"
                                     (cambio)="p.firmado = $event"></app-frc-firmado>
                    <button type="button" class="table-page__action-btn" (click)="frcDe(p)"
                            *ngIf="tieneFrc(p)" [disabled]="generandoFrc === p.idPermiso"
                            matTooltip="Bajar el FRC-017" aria-label="Bajar el FRC-017">
                      <span class="material-icons">description</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #perVacio>
          <div class="table-page__empty" *ngIf="!cargando; else perCargando">
            <span class="material-icons" aria-hidden="true">{{ mios.length ? 'inventory_2' : 'event_available' }}</span>
            <p>{{ mios.length ? 'Tus permisos están archivados: los ves en «Archivados».' : 'Todavía no has pedido ningún permiso.' }}</p>
          </div>
        </ng-template>

        <ng-template #perCargando>
          <div class="table-page__empty table-page__empty--loading">
            <span class="material-icons" aria-hidden="true">hourglass_top</span>
            <p>Consultando…</p>
          </div>
        </ng-template>

      </section>
    </div>

  </div>
  </div>

  <!-- La celda del permiso, igual en la bandeja y en la lista propia: el
       icono del tipo en su color (el del calendario de permisos), el día
       con su nombre como dato principal y, debajo, qué se pidió y el goce
       cuando ya se decidió. En «Tus permisos» trae además quién respondió
       (`quien`), que sólo se ve cuando la lista va como tarjeta en la
       columna derecha, sin columna «Quién responde». Aquí, fuera de los
       *ngIf de cada parte, para que la alcancen las dos. -->
  <ng-template #celdaPermiso let-p let-quien="quien">
    <div class="per-permiso">
      <span class="per-tipo" [ngClass]="tonoDe(p.tipo)" aria-hidden="true">
        <span class="material-icons">{{ iconoDe(p.tipo) }}</span>
      </span>
      <div class="table-page__cell-stack per-permiso__txt">
        <strong class="table-page__name per-dia">{{ diaLargo(p.fecha) }}</strong>
        <span class="table-page__subtext per-detalle">
          <span class="per-detalle__que">{{ detalle(p) }}</span>
          <span class="per-goce" *ngIf="p.goce" [class.es-con]="p.goce === 'CON'">
            {{ p.goce === 'CON' ? 'Con goce' : 'Sin goce' }}
          </span>
          <span class="per-detalle__quien" *ngIf="quien" [attr.title]="quien">
            <span class="material-icons" aria-hidden="true">person_outline</span>
            <span class="per-detalle__nombre">{{ quien }}</span>
          </span>
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #sinObs>
    <span class="per-vacio"><span aria-hidden="true">—</span><span class="cdk-visually-hidden">Sin observaciones</span></span>
  </ng-template>
</div>

<!-- ==================== FIRMA DEL FRC-017 ==================== -->
<!-- El mismo modal firma la solicitud propia (para="pedir") o la
     autorización de un permiso de la bandeja (para="autorizar"). -->
<app-firma-frc
  *ngIf="firmaAbierta"
  [para]="firmaPara"
  documento="FRC-017"
  [nombre]="firmaObjetivo?.colaborador"
  (firmada)="firmada($event)"
  (cancelada)="cancelaFirma()"
></app-firma-frc>
